import {useDispatch, useSelector} from 'react-redux';
import {
  selectPopupData,
  handleCurrentStep,
  setShowPopup,
  setPaymentAction,
  setSelectedBansForPaymentUpdate,
} from '../DebtAndUpdatePaymentBlockSlice';

export const useDebtPaymentPopupData = () => {
  const dispatch = useDispatch();

  const popupData = useSelector(selectPopupData);

  const actions = {
    goToStep: (step) => dispatch(handleCurrentStep(step)),
    setPaymentAction: (value) => dispatch(setPaymentAction(value)),
    setShowPopup: (popup) => dispatch(setShowPopup(popup)),
    setSelectedBansForPaymentUpdate: (bans) => dispatch(setSelectedBansForPaymentUpdate(bans)),
  };

  return {
    popupData,
    actions,
  };
};
